import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const CheckingConfigurationView: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 2,
        p: 3,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="h6" color="text.secondary">
        Checking LinkedIn Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        Please wait while we verify your LinkedIn settings...
      </Typography>
    </Box>
  );
}; 